// extracted by mini-css-extract-plugin
export default {"wrapper":"GB-z","addressLine":"HB-z","fullName":"IB-z"};